import { render, staticRenderFns } from "./EnhanceGroovy.vue?vue&type=template&id=1527af69&scoped=true&"
import script from "./EnhanceGroovy.vue?vue&type=script&lang=js&"
export * from "./EnhanceGroovy.vue?vue&type=script&lang=js&"
import style0 from "./EnhanceGroovy.vue?vue&type=style&index=0&id=1527af69&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1527af69",
  null
  
)

export default component.exports